if (!customElements.get('featured-collection-slider')) {
  customElements.define(
    'featured-collection-slider',
    class FeaturedCollectionSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.swiperModule = null;
        this.sectionId = this.getAttribute('data-section-id');
        this.enableDesktop = this.getAttribute('data-enable-desktop') === 'true';
        this.enableMobile = this.getAttribute('data-enable-mobile') === 'true';
        this.slidesDesktop = Number(this.getAttribute('data-slides-desktop')) || 3;
        this.slidesMobile = Number(this.getAttribute('data-slides-mobile')) || 1.2;
        this.gapDesktop = Number(this.getAttribute('data-gap-desktop')) || 16;
        this.gapMobile = Number(this.getAttribute('data-gap-mobile')) || 16;
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      }

      connectedCallback() {
        this.mediaQuery.addEventListener('change', this.handleBreakpointChange);

        if (window.Shopify?.designMode) {
          this.loadSwiper().then(() => requestAnimationFrame(() => requestAnimationFrame(() => this.sync())));
          return;
        }

        const observer = new IntersectionObserver(
          async (entries) => {
            if (entries[0].isIntersecting) {
              observer.disconnect();
              await this.loadSwiper();
              this.sync();
            }
          },
          { rootMargin: '200px' }
        );
        observer.observe(this);
      }

      async loadSwiper() {
        if (!this.swiperModule) {
          this.swiperModule = await import('https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs');
        }
        return this.swiperModule;
      }

      shouldEnable() {
        return this.mediaQuery.matches ? this.enableDesktop : this.enableMobile;
      }

      handleBreakpointChange() {
        this.sync();
      }

      sync() {
        if (!this.swiperModule || !this.swiperEls.swiperContainer) return;

        if (this.shouldEnable()) {
          if (this.swiper) {
            this.swiper.update();
          } else {
            this.initSwiper();
          }
        } else if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      initSwiper() {
        const Swiper = this.swiperModule.default;
        const { Navigation } = this.swiperModule;
        const { swiperContainer, prev, next } = this.swiperEls;

        this.swiper = new Swiper(swiperContainer, {
          modules: [Navigation],
          slidesPerView: this.slidesMobile,
          spaceBetween: this.gapMobile,
          watchOverflow: true,
          navigation: prev && next ? { nextEl: next, prevEl: prev } : false,
          observer: true,
          observeParents: true,
          breakpoints: {
            750: {
              slidesPerView: this.slidesDesktop,
              spaceBetween: this.gapDesktop,
            },
          },
        });

        if (!this.mutationObserver) {
          this.mutationObserver = new MutationObserver(() => this.swiper?.update());
          this.mutationObserver.observe(this, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.handleBreakpointChange);
        this.mutationObserver?.disconnect();
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }

      get swiperEls() {
        return {
          swiperContainer: this.querySelector(`[id^="Swiper-${this.sectionId}"]`),
          prev: this.querySelector(`[id^="Swiper-prev-${this.sectionId}"]`),
          next: this.querySelector(`[id^="Swiper-next-${this.sectionId}"]`),
        };
      }
    }
  );
}
